import React, { useState } from 'react';

const ContactPage = () => {
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  }; 

  return (
    <div className="min-h-screen bg-[#faeee2]">
      <section className="relative pt-40 pb-24 md:pt-48 md:pb-32 overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img
            src="/img/consult-1.avif" 
            alt="Modern Office Reception" 
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/80 to-black/60"></div>
        </div>
        
        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center" data-aos="fade-up">
          <span className="inline-block px-5 py-1.5 rounded-full bg-white/10 text-brand-orange border border-brand-orange/30 text-xs md:text-sm font-bold tracking-widest uppercase mb-6 backdrop-blur-sm">
            GET IN TOUCH
          </span>
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-serif font-bold text-white mb-6 leading-tight">
            Contact <span className="text-brand-orange">Us</span>
          </h1>
          <p className="text-base md:text-lg text-white/80 leading-relaxed max-w-2xl mx-auto">
            Schedule a strategy consultation or request comprehensive market research for your company.
          </p>
        </div>
      </section>

      <section className="py-24 px-6 relative">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16">
          <div data-aos="fade-right" className="flex flex-col justify-center">
            <h2 className="text-4xl md:text-5xl font-serif font-bold text-brand-deepBrown mb-6">Let's Connect</h2>
            <p className="text-brand-grayBrown text-lg leading-relaxed mb-10">
              Whether you need strategic management guidance, detailed market analysis, or expansion advisory, our team is ready to assist.
            </p>

            <div className="space-y-8 mb-12">
              <div className="flex items-start gap-6 bg-white p-6 rounded-2xl shadow-sm border border-[#f2decb]">
                <div className="w-14 h-14 rounded-full bg-[#faeee2] flex items-center justify-center text-brand-orange text-2xl shrink-0 border border-[#f2decb]">📍</div>
                <div>
                  <h4 className="font-serif font-bold text-brand-deepBrown text-xl mb-1">Head Office</h4>
                  <p className="text-brand-grayBrown">United Arab Emirates,<br/> Dubai, UAE</p>
                </div>
              </div>

              <div className="flex items-start gap-6 bg-white p-6 rounded-2xl shadow-sm border border-[#f2decb]">
                <div className="w-14 h-14 rounded-full bg-[#faeee2] flex items-center justify-center text-brand-orange text-2xl shrink-0 border border-[#f2decb]">✉️</div>
                <div>
                  <h4 className="font-serif font-bold text-brand-deepBrown text-xl mb-1">Email Inquiry</h4>
                  <p className="text-brand-grayBrown">info@consulting.com</p>
                </div>
              </div>

              <div className="flex items-start gap-6 bg-white p-6 rounded-2xl shadow-sm border border-[#f2decb]">
                <div className="w-14 h-14 rounded-full bg-[#faeee2] flex items-center justify-center text-brand-orange text-2xl shrink-0 border border-[#f2decb]">📞</div>
                <div>
                  <h4 className="font-serif font-bold text-brand-deepBrown text-xl mb-1">Direct Line</h4>
                  <p className="text-brand-grayBrown">+000 0 000 0000</p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white border border-[#f2decb] p-8 md:p-12 rounded-3xl shadow-2xl relative overflow-hidden" data-aos="fade-left">
            <div className="absolute top-0 right-0 w-64 h-64 bg-brand-orange/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2"></div>
            
            {submitted ? (
              <div className="text-center py-20 relative z-10">
                <div className="text-6xl mb-6">✅</div>
                <h3 className="text-3xl font-serif font-bold text-brand-deepBrown mb-4">Message Sent</h3>
                <p className="text-brand-grayBrown text-lg">Thank you for reaching out. Our advisory team will respond within 24 hours.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-6 relative z-10">
                <div>
                  <label className="block text-sm font-bold text-brand-darkBrown uppercase tracking-wider mb-2">Full Name</label>
                  <input
                    type="text"
                    required
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    className="w-full px-6 py-4 rounded-full bg-[#faeee2] border border-[#f2decb] text-brand-deepBrown focus:outline-none focus:border-brand-orange transition-colors font-medium"
                    placeholder="Enter Your Name"
                  />
                </div>
                <div>
                  <label className="block text-sm font-bold text-brand-darkBrown uppercase tracking-wider mb-2">Work Email</label>
                  <input
                    type="email"
                    required
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    className="w-full px-6 py-4 rounded-full bg-[#faeee2] border border-[#f2decb] text-brand-deepBrown focus:outline-none focus:border-brand-orange transition-colors font-medium"
                    placeholder="xyz@company.com"
                  />
                </div>
                <div>
                  <label className="block text-sm font-bold text-brand-darkBrown uppercase tracking-wider mb-2">Phone Number</label>
                  <input
                    type="tel"
                    value={formData.phone}
                    onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                    className="w-full px-6 py-4 rounded-full bg-[#faeee2] border border-[#f2decb] text-brand-deepBrown focus:outline-none focus:border-brand-orange transition-colors font-medium"
                    placeholder="+0 (000) 000-0000"
                  />
                </div>
                <div>
                  <label className="block text-sm font-bold text-brand-darkBrown uppercase tracking-wider mb-2">How Can We Help?</label>
                  <textarea
                    rows="5"
                    required
                    value={formData.message}
                    onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                    className="w-full px-6 py-4 rounded-2xl bg-[#faeee2] border border-[#f2decb] text-brand-deepBrown focus:outline-none focus:border-brand-orange transition-colors font-medium resize-none"
                    placeholder="Tell us about your management consulting or market research requirements..."
                  ></textarea>
                </div>
                <button
                  type="submit"
                  className="w-full py-5 rounded-full bg-brand-orange text-white font-bold hover:bg-brand-darkBrown transition-colors duration-300 shadow-xl uppercase tracking-wider text-sm mt-4"
                >
                  Send Inquiry
                </button>
              </form>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;